import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Check = makeShortcode("Check");
const Close2 = makeShortcode("Close2");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <table>
    <thead>
        <tr>
            <td className="w-3/12"></td>
            <td className="w-2/12 text-center"><a href="/blog/posthog-vs-hotjar">Hotjar</a></td>
            <td className="w-2/12 text-center"><a href="/blog/posthog-vs-logrocket">LogRocket</a></td>
            <td className="w-2/12 text-center"><a href="/blog/posthog-vs-matomo">Matomo</a></td>
            <td className="w-2/12 text-center"><a href="/blog/posthog-vs-fullstory">FullStory</a></td>
            <td className="w-3/12 text-center bg-gray-accent bg-opacity-50">
            <strong>PostHog</strong>
            </td>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>
                <strong>Session replay</strong>
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td className="bg-gray-accent bg-opacity-50">&nbsp;</td>
        </tr>
        <tr>
            <td>Single-page app support</td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="bg-gray-accent bg-opacity-50 text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
        </tr>
        <tr>
            <td>iOS recordings</td>
            <td className="text-center">
                <span className="text-red text-lg inline-block">
                    <Close2 mdxType="Close2" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-red text-lg inline-block">
                    <Close2 mdxType="Close2" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="bg-gray-accent bg-opacity-50 text-center">
                <span className="text-red text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
        </tr>
        <tr>
            <td>Android recordings</td>
            <td className="text-center">
                <span className="text-red text-lg inline-block">
                    <Close2 mdxType="Close2" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-red text-lg inline-block">
                    <Close2 mdxType="Close2" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="bg-gray-accent bg-opacity-50 text-center">
                <span className="text-red text-lg inline-block">
                    <Close2 mdxType="Close2" />
                </span>
            </td>
        </tr>
        <tr>
            <td>Identity detection</td>
            <td className="text-center">
                <span className="text-red text-lg inline-block">
                    <Close2 mdxType="Close2" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="bg-gray-accent bg-opacity-50 text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
        </tr>
        <tr>
            <td>Target recordings by URL</td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="bg-gray-accent bg-opacity-50 text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
        </tr>
        <tr>
            <td>Target by sample size</td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-red text-lg inline-block">
                    <Close2 mdxType="Close2" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-red text-lg inline-block">
                    <Close2 mdxType="Close2" />
                </span>
            </td>
            <td className="bg-gray-accent bg-opacity-50 text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
        </tr>
        <tr>
            <td>Filter recordings by user or event</td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="bg-gray-accent bg-opacity-50 text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
        </tr>
        <tr>
            <td>Rage-click detection</td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-red text-lg inline-block">
                    <Close2 mdxType="Close2" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="bg-gray-accent bg-opacity-50 text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
        </tr>
        <tr>
            <td>Privacy masking for sensitive content</td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="bg-gray-accent bg-opacity-50 text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
        </tr>
        <tr>
            <td>Export recordings</td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-red text-lg inline-block">
                    <Close2 mdxType="Close2" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
            <td className="bg-gray-accent bg-opacity-50 text-center">
                <span className="text-green text-lg inline-block">
                    <Check mdxType="Check" />
                </span>
            </td>
        </tr>
        <tr>
            <td>Retention policy for recordings</td>
            <td className="text-center">1 year</td>
            <td className="text-center">1 month</td>
            <td className="text-center">24 months</td>
            <td className="text-center">1 month</td>
            <td className="bg-gray-accent bg-opacity-50 text-center">
                <strong>PostHog Cloud:</strong> 3 weeks
                <br />
                <strong>Self-hosted:</strong> No limit
            </td>
        </tr>
    </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      